import { MakeModel } from '../../../make/model/make.model';
import { ProductModel } from '../../../product/model/product.model';
import { AssetTypeModel } from './asset-type.model';
import { SiteModel } from './site.mode';

export class AssetModel {
  id: number;
  isActive: boolean;
  customerAssetNumber: string;
  tag?: string;
  installDate: Date;
  manufacturedDate: Date;
  productId: number;
  serialNumber: string;
  siteId: string;
  product: ProductModel;
  site: SiteModel;
  make: MakeModel;
  assetType: AssetTypeModel;
  siteNumber: string;
  customerNumber: string;
  assetLocation: string;

  constructor() {
    // Silence is golden
  }
}

export class AssetProductModel {
  id: string;
  name: string;
  makeId: number;
  model?: string;
  type?: string;
  partNumber: string;
}
